import React from "react";
import "./styles.css";

const StarUI = ({ rating, setRating }) => {
  const handleChange = (e) => {
    setRating(e.target.value);
  };

  return (
    <div
      class="starrating risingstar d-flex justify-content-center flex-row-reverse"
      value={"1"}
    >
      <input
        type="radio"
        id="star5"
        name="rating"
        value="5"
        checked={rating === "5"}
        onChange={handleChange}
      />
      <label for="star5" title="5 star">
        5
      </label>
      <input
        type="radio"
        id="star4"
        name="rating"
        value="4"
        checked={rating === "4"}
        onChange={handleChange}
      />
      <label for="star4" title="4 star">
        4
      </label>
      <input
        type="radio"
        id="star3"
        name="rating"
        value="3"
        checked={rating === "3"}
        onChange={handleChange}
      />
      <label for="star3" title="3 star">
        3
      </label>
      <input
        type="radio"
        id="star2"
        name="rating"
        value="2"
        checked={rating === "2"}
        onChange={handleChange}
      />
      <label for="star2" title="2 star">
        2
      </label>
      <input
        type="radio"
        id="star1"
        name="rating"
        value="1"
        checked={rating === "1"}
        onChange={handleChange}
      />
      <label for="star1" title="1 star">
        1
      </label>
    </div>
  );
};

export default StarUI;
